module.exports = __webpack_public_path__ + "static/media/7.b934effe.svg";